import React, { useState } from 'react'
import { Button } from '@sainsburys-tech/bolt'

import { BadgesList } from '../UserProfile/UserProfile'
import config from '../../config/bazaarvoice.json'
import BazaarVoiceHelpfulnessContainer from '../BazaarVoiceHelpfulness/BazaarVoiceHelpfulnessContainer'

import * as Styled from './QuestionItem.style'

const GetUserProfileTextColumn = ({ profile, type }) => {
  const { name, contextAttributes, location } = profile
  const { Age, Gender } = contextAttributes
  const prefix = type === 'question' ? 'Question from' : 'Answered by'
  return (
    <>
      <div>
        {prefix} <strong>{name}</strong>
      </div>
      {Age && <div>Age: {Age}</div>}
      {location && <div>Location: {location}</div>}
      {Gender && <div>Gender: {Gender}</div>}
    </>
  )
}

const Oval = ({ letter }) => <Styled.Oval type={letter}>{letter}</Styled.Oval>

const Answers = ({ answers }) => answers.map((answer, key) => <AnswerItem answer={answer} answerKey={key} key={key} />)

const AnswerItem = ({ answer, answerKey }) => {
  const badgeUrls = config.REVIEWS.BADGE_IMAGE_URLS
  const badgeText = config.REVIEWS.BADGE_TESTER_TEXT

  const { helpfulness, content, id, profile } = answer
  const { submitted, badges } = profile
  const URL_REGEX = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.,~#?&//=]*)/g

  const sanitizedText = content.replace(
    URL_REGEX,
    match => `<a href=${match} target='_blank' class="a">${match.substr(0, 45)}...</a>`
  )
  const innerHtml = { __html: sanitizedText.replace(/\n/g, '<br>') }

  return (
    <Styled.Answer key={answerKey}>
      <Oval letter='A' />
      <div>
        <p itemProp='text' dangerouslySetInnerHTML={innerHtml} />
        <Styled.PersonInformation>
          <Styled.FlexColumn>
            <span>
              <GetUserProfileTextColumn profile={profile} />
            </span>
            <div>
              <BadgesList {...{ badges, badgeUrls, badgeText }} />
            </div>
          </Styled.FlexColumn>
          <div>{submitted}</div>
        </Styled.PersonInformation>
        {helpfulness && (
          <BazaarVoiceHelpfulnessContainer
            helpfulCount={helpfulness.helpful}
            unhelpfulCount={helpfulness.unhelpful}
            contentType='answer'
            contentId={id}
          />
        )}
      </div>
    </Styled.Answer>
  )
}

const QuestionItem = ({ question, partNumber, index }) => {
  const { attributes, id } = question
  const { title, content, profile, answers } = attributes
  const [footerContent, setFooterContent] = useState('View Contents')

  const ADD_ANSWER_URL = `/product/${partNumber}/questions?questionId=${id}`
  const openAnswerUrl = () => (window.location.href = ADD_ANSWER_URL) // eslint-disable-line

  const AnswerLinkFooter = ({ isOpen, toggleOpenfunc }) => {
    if (isOpen) setFooterContent('Close answers')
    else setFooterContent(`Read ${answers.length} answers`)
    if (answers.length > 0)
      return (
        <Styled.AnswerLink>
          <a
            onClick={toggleOpenfunc}
            onKeyPress={toggleOpenfunc}
            role='link'
            tabIndex='0'
            data-test='answer-link-footer'
          >
            {footerContent}
          </a>
        </Styled.AnswerLink>
      )
    return (
      <Styled.AnswerLink>
        <a href={ADD_ANSWER_URL} rel='nofollow' data-test='answer-question-link-footer'>
          Answer this question
        </a>
      </Styled.AnswerLink>
    )
  }

  const AccordionTitle = (
    <Styled.AccordionTitle>
      <Oval letter='Q' />
      <Styled.FlexColumn>
        <Styled.QuestionHeading data-test='qa-question-heading'>{title}</Styled.QuestionHeading>
        {content && <Styled.QuestionBody dangerouslySetInnerHTML={{ __html: content }} />}
      </Styled.FlexColumn>
    </Styled.AccordionTitle>
  )

  return (
    <Styled.Container>
      <Styled.AccordionItem
        index={index}
        hasBorderBottom
        title={AccordionTitle}
        data-test='accordion-question-item'
        customToggle={<></>}
        footer={<AnswerLinkFooter />}
        wrapperPadding={0}
      >
        <Styled.PersonInformation question>
          <GetUserProfileTextColumn profile={profile} type='question' />
        </Styled.PersonInformation>
        <Styled.AnswerContents
          data-test={`question-item-expanded-${footerContent === 'Close answers' ? 'true' : 'false'}`}
        >
          <Answers answers={answers} />
          {!!answers.length && (
            <Styled.ButtonContainer>
              <Button kind='secondary' onClick={openAnswerUrl} data-test='button-answer-this-question'>
                Answer this question
              </Button>
            </Styled.ButtonContainer>
          )}
        </Styled.AnswerContents>
      </Styled.AccordionItem>
    </Styled.Container>
  )
}

export default QuestionItem
export { QuestionItem, Answers, AnswerItem }
